import request from '@/utils/request'

/**
 * 黑名单接口
 *
 * 服务端四个接口全是 GET（含 add / remove 两个写操作），这里如实照抄，
 * 不擅自改成 POST —— 改了就对不上 ApiUserBlacklistController 的映射。
 *
 * 返回体里的用户 id 是雪花 ID，但服务端 UserInfoVO 已用 ToStringSerializer
 * 序列化成字符串，所以这里不需要像 campusAuth.js 那样接 json-bigint。
 */

/**
 * 分页获取我的黑名单
 *
 * 分页参数不是方法入参，服务端由 PageableInterceptor 从 query 上取，
 * 所以必须走 params 而不是 data。
 *
 * @param {Object} params
 * @param {Number} params.pageNo   页码，从 1 开始
 * @param {Number} params.pageSize 每页条数
 * @returns {Promise} data 为 MyBatis-Plus 分页对象：{ records, total, current, size, pages }
 */
export function getBlacklistList (params) {
  return request({
    url: '/v1/blacklist/list',
    method: 'get',
    params
  })
}

/**
 * 解除拉黑
 *
 * @param {String|Number} blockedUserId 被拉黑的用户 id
 */
export function removeBlacklist (blockedUserId) {
  return request({
    url: '/v1/blacklist/remove',
    method: 'get',
    params: { blockedUserId }
  })
}

/**
 * 拉黑用户
 *
 * @param {String|Number} blockedUserId 要拉黑的用户 id
 */
export function addBlacklist (blockedUserId) {
  return request({
    url: '/v1/blacklist/add',
    method: 'get',
    params: { blockedUserId }
  })
}

/**
 * 查询某个用户是否已被我拉黑
 *
 * @param {String|Number} blockedUserId 被检查的用户 id
 * @returns {Promise} data 为 boolean
 */
export function checkBlacklist (blockedUserId) {
  return request({
    url: '/v1/blacklist/check',
    method: 'get',
    params: { blockedUserId }
  })
}
